"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExtensionNames = void 0;
const react_1 = require("@remirror/react");
const react_2 = require("react");
const useExtensionNames = () => {
    const { manager } = (0, react_1.useRemirrorContext)();
    return (0, react_2.useMemo)(() => {
        const extensionNames = {};
        manager.extensions.forEach((extension) => {
            extensionNames[extension.name] = true;
        });
        return extensionNames;
    }, [manager]);
};
exports.useExtensionNames = useExtensionNames;
